/*================ Getters ============*/

// api module
export const SERVER_ERROR = "SERVER_ERROR";
export const SHOW_TRANSLATE = "SHOW_TRANSLATE";
export const APP_CLOSED = "APP_CLOSED";

// auth module
export const IS_LOGGED_IN = "IS_LOGGED_IN";
export const LOGGING_IN = "LOGGING_IN";
export const REQUESTING_RESET = "REQUESTING_RESET";
export const RESETTING_PASSWORD = "RESETTING_PASSWORD";
export const BAD_CREDS = "BAD_CREDS";
export const RESET_REQUEST_ERROR = "RESET_REQUEST_ERROR";
export const RESET_ERROR = "RESET_ERROR";
export const SUBMITTING_REGISTRATION = "SUBMITTING_REGISTRATION";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const USER = "USER";

// application module
export const APPLICATION = "APPLICATION";
export const APPLICATIONS_LIST = "APPLICATIONS_LIST";
export const APPLICATION_SUBMITTED = "APPLICATION_SUBMITTED";
export const LOADING_APPLICATION = "LOADING_APPLICATION";
export const SAVING_FORM = "SAVING_FORM";
export const SAVING_FORM_ERROR = "SAVING_FORM_ERROR";
export const CURRENT_STEP = "CURRENT_STEP";
export const CURRENT_STATUS = "CURRENT_STATUS";
export const FORM_VALUES = "FORM_VALUES";
export const APPLICATION_STATUS = "APPLICATION_STATUS";

//
//
/*============= Mutations ===============*/

// api module
export const MUTATE_SERVER_ERROR = "MUTATE_SERVER_ERROR";
export const MUTATE_SHOW_TRANSLATE = "MUTATE_SHOW_TRANSLATE";

// auth module
export const MUTATE_SET_USER_INFO = "MUTATE_SET_USER_INFO";
export const MUTATE_LOGOUT = "MUTATE_LOGOUT";
export const MUTATE_LOGGING_IN = "MUTATE_LOGGING_IN";
export const MUTATE_REQUESTING_RESET = "MUTATE_REQUESTING_RESET";
export const MUTATE_RESETTING_PASSWORD = "MUTATE_RESETTING_PASSWORD";
export const MUTATE_SUBMITTING_REGISTRATION = "MUTATE_SUBMITTING_REGISTRATION";
export const MUTATE_BAD_CREDS = "MUTATE_BAD_CREDS";
export const MUTATE_RESET_REQUEST_ERROR = "MUTATE_RESET_REQUEST_ERROR";
export const MUTATE_RESET_ERROR = "MUTATE_RESET_ERROR";
export const MUTATE_REGISTER_ERROR = "MUTATE_REGISTER_ERROR";

// application module
export const MUTATE_APPLICATION = "MUTATE_APPLICATION";
export const MUTATE_APPLICATIONS_LIST = "MUTATE_APPLICATIONS_LIST";
export const MUTATE_LOADING_APPLICATION = "MUTATE_LOADING_APPLICATION";
export const MUTATE_SAVING_FORM_ERROR = "MUTATE_SAVING_FORM_ERROR";
export const MUTATE_PARTIAL_FORM_VALUES = "MUTATE_PARTIAL_FORM_VALUES";
export const MUTATE_SAVING_FORM = "MUTATE_SAVING_FORM";
export const MUTATE_CURRENT_STEP = "MUTATE_CURRENT_STEP";
export const MUTATE_SUBMITTED_FORM = "MUTATE_SUBMITTED_FORM";

//
//
/*=============== Actions =================*/

// api module
export const SET_SERVER_ERROR = "SET_SERVER_ERROR";
export const SET_SHOW_TRANSLATE = "SET_SHOW_TRANSLATE";

// auth module
export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const REGISTER = "REGISTER";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REQUEST_PASSWORD_RESET = "REQUEST_PASSWORD_RESET";
export const RESET_PASSWORD = "RESET_PASSWORD";

// application module
export const LIST_USER_APPLICATIONS = "LIST_USER_APPLICATIONS";
export const NEW_APPLICATION = "NEW_APPLICATION";
export const LOAD_APPLICATION = "LOAD_APPLICATION";
export const SAVE_FORM_STEP = "SAVE_FORM_STEP";
export const SUBMIT_APPLICATION = "SUBMIT_APPLICATION";
